'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Component2 = require('../../Component');

var _Component3 = _interopRequireDefault(_Component2);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash.range');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Main = function (_Component) {
    _inherits(Main, _Component);

    function Main() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Main);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Main.__proto__ || Object.getPrototypeOf(Main)).call.apply(_ref, [this].concat(args))), _this), _this.template = _main2.default, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'toPage',
        value: function toPage(number) {
            if (typeof this.props.onChange === 'function') {
                this.props.onChange(number);
            }

            return this;
        }
    }, {
        key: 'toPrev',
        value: function toPrev() {
            var pages = this.props.page instanceof Array ? this.props.page : [this.props.page],
                prevPage = pages[0] - 1;

            if (pages.length && prevPage > 0) {
                return this.toPage(prevPage);
            } else {
                return this;
            }
        }
    }, {
        key: 'toNext',
        value: function toNext() {
            var pages = this.props.page instanceof Array ? this.props.page : [this.props.page],
                nextPage = pages[pages.length - 1] + 1;

            if (pages.length && nextPage <= this.props.totalPages) {
                return this.toPage(nextPage);
            } else {
                return this;
            }
        }
    }, {
        key: 'isPageSelected',
        value: function isPageSelected(number) {
            var pages = this.props.page instanceof Array ? this.props.page : [this.props.page];

            return pages.indexOf(number) >= 0;
        }

        /**
         * подготавливает ряд отображаемых страниц без сокращений и разделителей
         * [1, 2, 3] => 1, 2, 3, 4, 5, ...visiblePages
         * @param {Number|Array} selected
         * @param {Number} totalPages
         * @param {Number} maxLength
         * @return {Array}
         * @private
         */

    }, {
        key: '_getPagesRow',
        value: function _getPagesRow() {
            var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.page;
            var totalPages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.totalPages;
            var maxLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props.visiblePages;

            selected = selected instanceof Array ? selected : [selected];
            var result = [],
                firstSelected = Number(selected[0]),
                lastSelected = Number(selected[selected.length - 1]);

            if (selected.length) {
                var restLength = totalPages > maxLength ? maxLength - selected.length : totalPages - selected.length;

                // selected list starts with 1
                if (firstSelected === 1) {
                    result = [].concat(selected, (0, _lodash2.default)(lastSelected + 1, lastSelected + 1 + restLength));
                } else if (lastSelected === totalPages) {
                    result = [].concat((0, _lodash2.default)(firstSelected - restLength, firstSelected), selected);
                } else {
                    var i = 0,
                        next = void 0,
                        prev = void 0,
                        beforePages = [],
                        afterPages = [],
                        beforeCounter = 1,
                        afterCounter = 1,
                        middlePagesLength = restLength - 2;

                    // заполняем средину, без первой и последней страницы
                    for (i; i < middlePagesLength; i++) {
                        next = lastSelected + afterCounter;
                        prev = firstSelected - beforeCounter;

                        // try to add after page
                        if (i % 2 === 0) {
                            if (next <= totalPages - 1) {
                                afterPages.push(next);
                                afterCounter += 1;
                            } else {
                                beforePages.unshift(prev);
                                beforeCounter += 1;
                            }
                            // try to add before page
                        } else {
                            if (prev >= 2) {
                                beforePages.unshift(prev);
                                beforeCounter += 1;
                            } else {
                                afterPages.push(next);
                                afterCounter += 1;
                            }
                        }
                    }

                    // add first page if its not exist
                    if (beforePages[0] !== 1 && firstSelected !== 1) {
                        beforePages.unshift(1);
                    }

                    // add last page if its not exist
                    if (afterPages.length[afterPages.length - 1] !== totalPages && lastSelected !== totalPages) {
                        afterPages.push(totalPages);
                    }

                    result = [].concat(beforePages, selected, afterPages);

                    // результат больше максимальной длинны - необходимо сократить выбранные страницы
                    if (result.length > maxLength) {
                        // выбранные страницы сокращаем до первой и последней выбранной
                        selected = [firstSelected, lastSelected];

                        // добавляем предыдущую относительно первой выбранной странице
                        if (lastSelected + 1 < afterPages[afterPages.length - 1]) {
                            afterPages.unshift(lastSelected + 1);
                        }

                        // добавляем следующую за последней выбранной страницей
                        if (firstSelected - 1 > beforePages[0]) {
                            beforePages.push(firstSelected - 1);
                        }

                        result = [].concat(beforePages, selected, afterPages);
                    }
                }
            } else {
                result = (0, _lodash2.default)(1, maxLength);
            }

            return result;
        }
    }]);

    return Main;
}(_Component3.default);

Main.defaultProps = {
    page: [1],
    incrementButton: true,
    decrementButton: true,
    visiblePages: 6
};
Main.propTypes = {
    page: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.number]),
    totalPages: _propTypes2.default.number.isRequired,
    incrementButton: _propTypes2.default.bool,
    decrementButton: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    visiblePages: _propTypes2.default.number
};
Main.displayName = 'Pagination';
exports.default = Main;